import { render } from "./TopNavSearch.vue?vue&type=template&id=ba4ef31c"
import script from "./TopNavSearch.vue?vue&type=script&lang=js"
export * from "./TopNavSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__